// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { store } from './store'

require('./assets/css/main.css')

//Import router for page navigation
import router from './router'

//Import third party resources
import RadialProgressBar from 'vue-radial-progress'
import * as VueGoogleMaps from 'vue2-google-maps'
import firebase from 'firebase'
import VueCookies from 'vue-cookies'
import VueLocalStorage from 'vue-localstorage'
import VueResource from 'vue-resource'
import axios from 'axios'
import cors from 'cors'
import sha256 from 'js-sha256'
import Toasted from 'vue-toasted'

import threeFBXLoader from '../static/FBXLoader-modified.js'
import threeTrackBallControls from '../static/trackballcontrols.js'

//Declare all global components
Vue.component('radial-progress-bar', RadialProgressBar)

//Declare all global plugins

Vue.use(threeFBXLoader)
Vue.use(threeTrackBallControls)

Vue.use(VueCookies)
Vue.use(VueLocalStorage)
Vue.use(cors)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBIgWkXLfO8bgbBfQF_N-r7Ut0SK0DRzRE',
    libraries: 'places',
  }
})
Vue.use(Toasted)

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  created () {
    firebase.initializeApp({
      apiKey: "AIzaSyAPJ2y2IMg66YFcwhJQdE2mV7tjlDVTlgk",
      authDomain: "knosis-beta.firebaseapp.com",
      databaseURL: "https://knosis-beta.firebaseio.com",
      projectId: "knosis-beta",
      storageBucket: "knosis-beta.appspot.com",
      messagingSenderId: "1019416557389"
    })
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        let permission = null
        firebase.database().ref('/admin/').once('value')
          .then((data) => {
            const obj = data.val()
            for (let key in data.val()) {
              if (key == user.uid) {
                this.$store.dispatch('autoAdminSignIn', user)
                this.$store.dispatch('fetchAdminData')
              }
            }
          })
        firebase.database().ref('/users/').once('value')
          .then((data) => {
            const obj = data.val()
            for (let key in data.val()) {
              if (key == user.uid) {
                this.$store.dispatch('autoSignIn', user)
                this.$store.dispatch('fetchUserData')
                this.$store.dispatch('fetchUserPosition')
                this.$store.dispatch('fetchAvatarData')
                this.$store.dispatch('loadChallenges')
                this.$store.dispatch('loadPastChallenges', user)
                this.$store.dispatch('loadAvailableChallengers', user)
                this.$store.dispatch('loadMapCenter')
              }
            }
          })
        }
    })
  },
})



// WEBPACK FOOTER //
// ./src/main.js